import { Attachment, IAttachment } from '../../../components/attachment-upload-btn/attachment';

export interface IReference {
  _id?: string;
  attachment?: IAttachment[];
  company?: string;
  document_title?: string;
  email?: string;
  name?: string;
  phone?: string;
  position?: string;
}

export class Reference implements IReference {
  _id?: string;
  attachment: Attachment[];
  company: string;
  document_title: string;
  email: string;
  name: string;
  phone: string;
  position: string;

  constructor( reference: IReference = {} ) {
    this._id = reference._id;
    this.attachment = (reference.attachment || []).map(( item ) => new Attachment(item));
    this.company = reference.company;
    this.document_title = reference.document_title;
    this.email = reference.email;
    this.name = reference.name;
    this.phone = reference.phone;
    this.position = reference.position;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/reference.ts